const GROUP_SPECIALTY = "GROUP_SPECIALTY";
const GROUP_SPECIALTY_MAP = "GROUP_SPECIALTY_MAP";
const VEEVA_SPECIALTY = "VEEVA_SPECIALTY";

export const setGroupSpecialty = (payload) => {
    return {
        type: GROUP_SPECIALTY,
        payload: [...payload],
    };
};

export const setMapSpecialty = (payload) => {
    return {
        type: GROUP_SPECIALTY_MAP,
        payload: [...payload],
    };
};

export const setVeevaSpecialty = (payload) => {
    return {
        type: VEEVA_SPECIALTY,
        payload: [...payload],
    };
};

const initialState = {
    groupSpecialty: [],
    mapSpecialty: [],
    veevaSpecialty: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GROUP_SPECIALTY:
            if (!action.payload) {
                return {
                    ...initialState.groupSpecialty,
                };
            }
            return { ...state, groupSpecialty: [...action.payload] };
        case GROUP_SPECIALTY_MAP:
            if (!action.payload) {
                return {
                    ...initialState.mapSpecialty,
                };
            }
            return { ...state, mapSpecialty: [...action.payload] };
        case VEEVA_SPECIALTY:
            if (!action.payload) {
                return {
                    ...initialState.mapSpecialty,
                };
            }
            return { ...state, veevaSpecialty: [...action.payload] };
        default:
            return state;
    }
};
